export class AuthError extends Error {
    constructor(code, message, cause) {
        super(message || code);
        this.code = code;
        this.cause = cause;
        this.name = 'AuthError';
    }
}
